function multiPropertySort(sortBy, sortArray) {
  // arrayProps should be structured as follows
  // [{prop: '<propName>', direction: < -1,1 >, ...}]

  let results = sortArray.sort(function(a, b) {
    let i = 0,
      result = 0
    while (i < sortBy.length && result === 0) {
      result = sortBy[i].direction * (a[sortBy[i].prop] < b[sortBy[i].prop] ? -1 : a[sortBy[i].prop] > b[sortBy[i].prop] ? 1 : 0)
      i++
    }
    return result
  })

  return results
}

function multiPropertySortWithNullConcat(sortBy, sortArray, nullProp) {
  // arrayProps should be structured as follows
  // [{prop: '<propName>', direction: < -1,1 >, ...}]
  // nullProp is a string

  // the whole idea here is too sort approvals, first sort approvals with a decision by date,
  // then tack on the approvals that have not been responded too.  Is this function useful elsewhere,
  // doubt it but who knows

  let nullItems = sortArray.filter(i => {
    return i[nullProp] == null
  })

  let sortableItems = sortArray.filter(i => {
    return i[nullProp] != null
  })

  let results = sortableItems.sort(function(a, b) {
    let i = 0,
      result = 0
    while (i < sortBy.length && result === 0) {
      result =
        sortBy[i].direction *
        (String(a[sortBy[i].prop]) < String(b[sortBy[i].prop])
          ? -1
          : String(a[sortBy[i].prop]) > String(b[sortBy[i].prop])
          ? 1
          : 0)
      i++
    }
    return result
  })

  return results.concat(nullItems)
}

/*********************************************************** 
 How to use multiFilter                                     
 items,  array of objects to filter                   
 filters,  {} object of filter props                    
 let items = [{name: 'Tony', color: 'red'},{name: 'Debi', color: 'purple'}, {name: 'Kate', color: 'purple'}, {name: 'Noah', color: 'blue'}]   
 let filters = {color:['red', 'blue']}
 multiFilter(items, filters)
************************************************************/

const multiFilter = (items, filters) => {
  if (items && filters) {
    return items.filter(item => {
      return Object.entries(filters).every(([filterProperty, filterValues]) => {
        switch (Object.prototype.toString.call(item[filterProperty])) {
          case '[object Object]':
            return Object.entries(filterValues).every(([extFilterProperty, extFilterValue]) => {
              return new Map(Object.entries(item[filterProperty])).get(extFilterProperty) === extFilterValue
            })

          case '[object Array]':
            return item[filterProperty].some(itemValue => {
              return filterValues.includes(itemValue)
            })

          default:
            return filterValues.includes(item[filterProperty])
        }
      })
    })
  }
}

export { multiPropertySort, multiPropertySortWithNullConcat, multiFilter }
